import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-criteria',
    templateUrl: './criteria.component.html',
    styleUrls: ['./criteria.component.scss'],
    standalone: false // NOSONAR
})
export class CriteriaComponent implements OnInit {
  @Input() group!: any;
  @Input() options!: any;
  @Input() isRootGroup: boolean = false;  // Indicates if it's the first (undeletable) group

  constructor(private readonly fb: FormBuilder) {}

  ngOnInit(): void {
    console.info('something')
  }

  get rulesArray(): FormArray {
    return this.group.get('rules') as FormArray;
  }

  get groupArray(): FormArray {
    return this.group.get('group') as FormArray;
  }

  addRule() {
    this.rulesArray.push(this.fb.group({
      condition: ['AND'],
      fieldId: ['',[Validators.required]],
      fieldOper: ['',[Validators.required]],
      fieldValue: ['',[Validators.required]],
      fieldType: [''],
    }));
  }

  removeRule(index: number) {
    this.rulesArray.removeAt(index);
    if (this.rulesArray.length == 0 && this.groupArray.length == 0 && !this.isRootGroup) { // NOSONAR
      this.removeThisGroup();
    }
  }

  removeThisGroup() {
    const parentFormArray = this.findParentGroupArray();
    if (parentFormArray) {
      const groupIndex = parentFormArray.controls.indexOf(this.group);
      if (groupIndex != -1) { // NOSONAR
        parentFormArray.removeAt(groupIndex);
      }
    }
  }

  findParentGroupArray(): FormArray | null {
    let parentFormArray: FormArray | null = null;
    let parent = this.group.parent;

    while (parent) {
      if (parent instanceof FormArray) {
        parentFormArray = parent;
        break;
      }
      parent = parent.parent;
    }

    return parentFormArray;
  }

  createRuleFormGroup(ruleData: any): FormGroup {
    return this.fb.group({
      fieldId: [ruleData.fieldId,[Validators.required]],
      fieldOper: [ruleData.fieldOper,[Validators.required]],
      fieldValue: [ruleData.fieldValue,[Validators.required]],
      fieldType: [ruleData.fieldType],
      filterLevel: [ruleData.filterLevel],
      filterSeq: [ruleData.filterSeq]
    });
  }

  addGroup(parentGroupControl: AbstractControl) {
    const parentGroup = parentGroupControl.get('group') as FormArray;
    if (!parentGroup) {
      console.info('Invalid group structure');
      return;
    }

    const newGroup = this.fb.group({
      condition: ['AND'],
      rules: this.fb.array([
        this.createRuleFormGroup({
          fieldId: ['',[Validators.required]],
          fieldOper: ['',[Validators.required]],
          fieldValue: ['',[Validators.required]],
          fieldType: '',
          filterLevel: 0,
          filterSeq: 0
        })
      ]),
      group: this.fb.array([])
    });

    parentGroup.push(newGroup);
  }

  removeGroup(index: number) {
    this.groupArray.removeAt(index);
  }

  getOperatorOptions(value: any) {
    console.info(value)
  }

  findValueById(id: string, key: string) {
    const foundObject = this.options?.find(item => item.id == id); // NOSONAR
    return foundObject ? foundObject[key] : [];
  }
  isRulesArrayInvalid():boolean{
    const rulesArray = this.group.get('rules') as FormArray;
    return rulesArray && rulesArray.length == 0 && rulesArray.touched; // NOSONAR
  }
}